import { match } from 'ts-pattern';

import type { ClientListItem } from '@/entities/client';

// dateOfBirth was dropped from the list contract (PR #638 review); restoring it needs the field back.
// type MissingField = 'acuity' | 'dateOfBirth' | 'pronouns' | 'treatmentApproach' | 'treatmentFocus';
type MissingField = 'acuity' | 'pronouns' | 'treatmentApproach' | 'treatmentFocus';

export function getClientCompletion(client: ClientListItem): {
    percentage: number;
    missing: MissingField[];
} {
    const missing = new Set<MissingField>([
        'acuity',
        // 'dateOfBirth',
        'pronouns',
        'treatmentApproach',
        'treatmentFocus',
    ]);

    Object.entries(client).forEach(([key, value]) => {
        const field = key as MissingField;
        if (missing.has(field) && value) {
            missing.delete(field);
        }
    });

    const missingArr = [...missing];

    const completion = missingArr
        .map((x) =>
            match(x)
                .with('acuity', () => -5)
                // .with('dateOfBirth', () => -20)
                .with('pronouns', () => -20)
                .with('treatmentApproach', () => -20)
                .with('treatmentFocus', () => -20)
                .exhaustive(),
        )
        .reduce((acc, curr) => acc + curr, 100);

    return { percentage: completion, missing: missingArr };
}
